import React, { useState } from 'react';
import { Typography, Grid, FormGroup } from '@material-ui/core';
import Link from 'components/MuiRouterLink';
import EnhancedTextField from 'components/EnhancedTextField';
import PendingButton from 'components/PendingButton';
import Header from 'components/Header';
import useHandler from 'handlers/useLoginHandler';
import useCustomTheme from 'theme/useCustomTheme';
import routes from 'utils/routes';

const Login = (): JSX.Element => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, handler] = useHandler();
  const theme = useCustomTheme();
  const hideDirections = theme.custom?.pages?.login?.hideDirections;

  return (
    <FormGroup>
      <Grid container>
        <Header
          title='Sign In'
          directions='Please enter your email address or username and password to log into your account.'
          hideDirections={hideDirections}
        />
        <EnhancedTextField
          autoFocus
          outerLabel='Email Address or Username'
          name='username'
          type='text'
          onChange={ev => setUsername(ev.target.value?.trim()?.toLowerCase())}
        />
        <EnhancedTextField
          outerLabel='Password'
          name='password'
          type='password'
          onChange={ev => setPassword(ev.target.value)}
        />
        <Grid container>
          <PendingButton onClick={() => handler({ username, password })} isPending={isLoading}>
            Sign In
          </PendingButton>
          <Typography variant='body2'>
            <Link to={routes.forgotPassword}>Forgot your password?</Link>
          </Typography>
        </Grid>
      </Grid>
    </FormGroup>
  );
};

export default Login;
